import React from 'react'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down/index.js'
import getStyleComponentUtil from 'modules/component/utils/get-style/index.js'

export function ArrowRightIcon (props) {
  const style = getStyleComponentUtil(props.style, {
    transform: 'rotate(-90deg)'
  })
  return (
    <ArrowDownIcon {...props} style={style} />
  )
}
